<template>
    <div class="maijia_head">
        <img src="../assets/images/mj-logo-white.png" alt="">
        <div @click="handleLanguageChange">
            {{$i18n.locale=='en'?'中文':'EN'}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    created() {
        this.$i18n.locale = localStorage.getItem('locale') || 'zh'
    },
    methods: {
        handleLanguageChange() {
            this.$i18n.locale = this.$i18n.locale == 'en' ? 'zh' : 'en'
            localStorage.setItem('locale', this.$i18n.locale)
        }
    }
    // destory(){
    //     localStorage.setItem('locale', 'zh')
    // }
}
</script>

<style lang="scss" scoped>
.maijia_head {
    height: 80px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.maijia_head > img {
    width: 141px;
    height: 36px;
}
.maijia_head > div {
    color: #fff;
    font-size: 18px;
}
</style>